"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HISLogo = (_a) => {
    var { scale, reserveFill = false } = _a, props = __rest(_a, ["scale", "reserveFill"]);
    const mainFill = reserveFill ? '#fff' : '#0057B8';
    const secondaryFill = reserveFill ? '#0057B8' : '#fff';
    return (react_1.default.createElement("svg", Object.assign({ width: 49 * scale, height: 20 * scale, viewBox: "0 0 49 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M40.49 18.85c4.7 0 8.51-3.985 8.51-8.9 0-4.915-3.81-8.9-8.51-8.9-4.699 0-8.509 3.985-8.509 8.9 0 4.915 3.81 8.9 8.51 8.9z", fill: mainFill }),
        react_1.default.createElement("path", { d: "M40.443 15.5a4.043 4.043 0 01-2.534-.8c-.645-.525-1.028-1.275-1.1-2.125V12.5h1.96v.05c.144.725.885 1.25 1.745 1.25.86 0 1.65-.55 1.65-1.375S41.734 11.3 40.8 11l-1.29-.425c-1.22-.35-2.654-1.15-2.654-3.025S38.363 4.4 40.42 4.4a3.526 3.526 0 012.342.8 2.904 2.904 0 011.028 2.125v.05h-1.984v-.05c-.12-.725-.74-1.25-1.458-1.2-.884 0-1.506.6-1.506 1.375s.215.975 1.243 1.3l1.1.35c.717.2 1.41.525 2.008 1 .597.525.956 1.3.932 2.125a2.99 2.99 0 01-1.148 2.45c-.74.525-1.625.8-2.533.775z", fill: secondaryFill }),
        react_1.default.createElement("path", { d: "M14.939 18.35H0l6.956-16.8h14.939l-6.956 16.8z", fill: mainFill }),
        react_1.default.createElement("path", { d: "M15.154 4.6L13.338 9H9.346l1.816-4.4h-2.15L4.612 15.275h2.151l1.745-4.25h3.992l-1.769 4.25h2.152L17.305 4.6h-2.15z", fill: secondaryFill }),
        react_1.default.createElement("path", { d: "M25.91 18.35h-8.82l6.956-16.8h8.82l-6.956 16.8z", fill: mainFill }),
        react_1.default.createElement("path", { d: "M26.101 4.6l-4.398 10.675h2.127L28.252 4.6h-2.15z", fill: secondaryFill })));
};
exports.default = HISLogo;
